import { Handle, Position, type Node, type NodeProps } from 'reactflow'
import styles from '../AssetNode/flowNodes.module.scss'

export type PlaceholderNodeType = Node<{ label: string }, 'placeholder'>

export function PlaceholderNode({ data }: NodeProps<{ label: string }>) {
  return (
    <div className={styles.placeholder}>
      <Handle id="target" type="target" position={Position.Left} className={styles.handle} />
      <span className={styles.placeholderLabel}>{data.label}</span>
      <Handle id="source" type="source" position={Position.Right} className={styles.handle} />
    </div>
  )
}
